import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';

import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';
import { NgSessionStorage, NgLocalStorage } from 'core/utils/ng-storage.service';
import { PendingService } from 'core/pending.service';
@Directive({
  selector: '[appDisabledWorkflowElement]'
})
export class DisabledWorkflowElementDirective implements OnInit, OnDestroy {
  @Input() appDisabledWorkflowElement;
  @Input() entity = '';
  @Input() parentRecordGUIDS;
  @Input() disabled;
  @Input() dataRecordGUID;

  entityListDisabled: any;

  constructor(private pendingService: PendingService, private eleRef: ElementRef,private ngSessionStorage: NgSessionStorage, private ngLocalStorage: NgLocalStorage, private msalService: MsalService, private _auth: AuthenticationService) {
    let jsonString = this.pendingService.getEntityListDisabled();
    this.entityListDisabled = JSON.parse(jsonString);
    // let jsonString = this.ngSessionStorage.getItem('entityListDisabled');
    // this.entityListDisabled = JSON.parse(jsonString);
    // console.log('this.entityListDisabled - ', this.entityListDisabled);
  }

  disableClass = function () {
    this.disabled = true;
    this.eleRef.nativeElement.style.pointerEvents = 'none';
    this.eleRef.nativeElement.style.cursor = 'not-allowed !important';
    this.eleRef.nativeElement.style.opacity = '0.45';
    this.entityListDisabled.forEach(value => {
      if (value.Level == 'Resources') {
        value["disabled"] = true;
      } else {
        if (value.RecordGUID == this.dataRecordGUID) {
          value["disabled"] = true;
        }
      }
    });
  };
  enableClass = function () {
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
    this.eleRef.nativeElement.style.cursor = 'pointer';
    this.entityListDisabled.forEach(value => {
      if (value.Level == 'Resources') {
        value["disabled"] = false;
      } else {
        if (value.RecordGUID == this.dataRecordGUID) {
          value["disabled"] = false;
        }
      }
    });
  };
  response = JSON.parse(this.ngLocalStorage.getItem('workflowUserRoles'));
  view = true;
  edit = false;
  roles = this._auth.getUserRoles(this.msalService);
  parentHasAccess = true;
  parentAccessArray = [];
  enabled = false;
  parentInList = false;
  ngOnInit() {
    		// this.roles = ['PDM-ReadOnly','PDM-InitialAccess', 'PDM-VerticalMarketing']; // For testing purpose only, to be removed later

    this.roles.forEach(value => {
      // let copyOfRoles = this._auth.getUserRoles(this.msalService);
      let userRolePermissions = this.response.filter(itm => { if (itm.RoleName == value) { return itm } });
      if (userRolePermissions.length != 0 && userRolePermissions[0][this.appDisabledWorkflowElement][this.entity]) {
        if (this.parentRecordGUIDS != "") {
          this.parentAccessCheck();
          if (this.parentAccessArray.indexOf("noteditable") === -1) {
            this.edit = true;
          } else {
            this.edit = false;
          }
        } else {
          this.edit = true;
          this.enabled = true
        }
      }
    });
    this.edit ? this.enableClass() : this.disableClass();
  }
  checkForAllRolesAccess = function (entityGroup) {
    this.parentHasAccess = false;
    this.roles.forEach(parentvalue => {
      let parentRolePermissions = this.response.filter(itm => { if (itm.RoleName == parentvalue) return itm });
      if (parentRolePermissions.length != 0 && parentRolePermissions[0][entityGroup][this.entity]) {
        this.parentHasAccess = true;
      }
    });
    if (this.parentHasAccess) {
      this.parentAccessArray.push("editable") //can maintain flag
    } else {
      this.parentAccessArray.push("noteditable")
    }
  }
  parentAccessCheck = function () {
    this.entityList = this.entityListDisabled;
    this.parentExist = false;
    do {
      this.parentExist = false;
      this.parentExist = false;
      var parentRecordGUIDSList = this.parentRecordGUIDS.split(',');
      parentRecordGUIDSList.forEach(parentRecordGUID => {
        this.entityList.forEach(value => {
          if (value.RecordGUID == parentRecordGUID) {
            let parentGuid = this.entityList.filter(itm => { if (itm.RecordGUID == value.RecordGUID) { return itm } });
            if (parentGuid.length != 0) { //can be eliminated
              this.parentExist = true;
              this.checkForAllRolesAccess(parentGuid[0].EntityGroup);
              if (parentGuid[0].ParentEntityList != "") {
                parentRecordGUID = parentGuid[0].ParentEntityList;
              } else {
                this.parentRecordGUIDS = "";
                this.parentExist = false;
              }
            }
          }
        });
      });
      if (!this.parentExist)
        this.parentRecordGUIDS = "";
    } while (this.parentRecordGUIDS != "" && this.parentExist)
  };


  ngOnDestroy() {

  }
}